import React, { useContext, useEffect, useRef, useState } from 'react'
import { IoDocumentAttachSharp } from 'react-icons/io5'
import { ColumnsTable } from 'safe'
import Table from '../../../components/Display/Table'
import { ColumnItemWrapper } from '../../../components/General/ColumnItemWrapper'
import {
  dateToDB,
  formatPipe,
  getDenomination,
  getItemType,
  getIvaNumber,
  getYearMonthAndDay,
  transformDate,
} from '../../../utils/utils'
import { ThemeContext } from '../../../context/ThemeContext'
import ReturnForm from './ReturnForm'
import Button from '../../../components/General/Button'
import axios from 'axios'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'
import Select from '../../../components/Inputs/Select'
import ReturnFormCredit from './ReturnFormCredit'
import { DateTime } from 'luxon'
import { toFixed } from 'accounting'

const server = process.env.REACT_APP_SERVER_URL

const Return: React.FC<IPurchase> = ({ purchase, onClose, isFromReturn, url = 'purchase' }) => {
  const { addAlert } = useSnackBars()

  const { theme } = useContext(ThemeContext)

  const [items, setItems] = useState<any[]>([])

  const [returnedPayments, setReturnedPayments] = useState<any[]>(
    purchase?.refunds?.map((v) => ({ ...v, state: 'old' })) || []
  )

  const [options] = useState([
    { text: 'De contado', value: 1 },
    { text: 'Crédito', value: 2 },
  ])

  // const [credit, setCredit] = useState<string | null>(null)

  const credit = useRef()

  const [globalRate, setGlobalRate] = useState<any>(null)

  console.log('ver el purchase...', purchase)
  const [selectedOption, setSelectedOption] = useState(options[0])

  useEffect(() => {
    setItems(purchase?.items.map((v) => ({ ...v, return: 1 })))
  }, [purchase?.items])

  const getGlobalRate = async () => {
     let response = await axios.get(
        `${server}/finances/rate?date=${purchase.date}&currency=all`
      )
      setGlobalRate(response.data.rates)
  }

  useEffect(() => {
    if (purchase) {
      getGlobalRate()
    }
  }, [purchase])

  const onGetRate = (idCurrency: string | undefined): string => {
    return globalRate.find((rate) => rate.id === idCurrency)?.rate || '1'
  }
  
  const onChange = (record, e) => {
    console.log("e.", e?.target?.value)
    console.log(e?.target?.value === '')
    if ( (!Number.isNaN(+e.target.value) && +e?.target?.value <= +record?.amount && +e.target?.value > 0) || e?.target?.value === '') {
      console.log("selected new... 2", items)
      let newArray = items.map((item) => {
        if (item.id === record?.id) {
          return {
            ...item,
            return: e?.target?.value,
          }
        }
        return item
      })

      console.log("selected new...", newArray)

      setItems(newArray)
    }
  }

  console.log('purchase...', purchase)

  const onPushReturn = (values) => {
    console.log('Values...', values)
  }

  const itemsColumns: ColumnsTable[] = [
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {getItemType(record?.type)?.value}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Cantidad',
      dataIndex: 'amount',
      key: 'amount'
      // render: (id: number, record: any) => (
      //   <ColumnItemWrapper
      //     subElement="paragraph"
      //     subElementStyle={`${record?.barcode ? '' : 'text-gray-600'}`}
      //   >
      //     {record?.barcode ? record?.barcode : 'N/A'}
      //   </ColumnItemWrapper>
      // ),
    },
    // {
    //   title: 'Excento',
    //   dataIndex: 'exempt',
    //   key: 'exempt',
    //   render: (id: number, record: any) => (
    //     <ColumnItemWrapper>
    //       <p>{record?.exempt ? 'Sí' : 'No'}</p>
    //     </ColumnItemWrapper>
    //   ),
    // },
    {
      title: 'Costo',
      dataIndex: 'cost',
      key: 'cost',
      // render: (id: number, record: any) => (
      //   <ColumnItemWrapper>
      //     <p
      //       className={`${
      //         !(record?.cost.length > 0) ? 'text-warning' : 'text-success'
      //       }`}
      //     >
      //       {record?.cost.length > 0 ? (
      //         'Bs ' + record?.cost[0]?.amount
      //       ) : (
      //         <span>
      //           Sin Precio <FiAlertTriangle className="text-warning inline" />
      //         </span>
      //       )}
      //     </p>
      //   </ColumnItemWrapper>
      // ),
    },
    {
      title: 'Devolución',
      dataIndex: 'return',
      key: 'return',
      render: (id: number, record: any) => {
        if (isFromReturn) {
          return (
            <input
              style={{ width: 80 }}
              onChange={(e) => onChange(record, e)}
              value={record?.return}
              className="cursor-text transition w-3/6 dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
              type="text"
              min={"1"}
              max={record?.amount}
            />
          )
        }
        return (
          <ColumnItemWrapper>
            <p>{record.returned}</p>
          </ColumnItemWrapper>
        )
      },
    },
  ]

  const returnColum: ColumnsTable[] = [
    {
      title: 'Cuenta',
      dataIndex: 'account.name',
      key: 'account.name',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {/* {getItemType(record?.type)?.value} */}
          { record?.account?.name || record?.account?.description }
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => {
        let [year, month, day] = record.date.split("-")
        let date = new Date(year, month - 1, day).toISOString()
        let newDate = DateTime.fromISO(date).toLocaleString({day: '2-digit', month: '2-digit', year: 'numeric'})
        return (
        <ColumnItemWrapper subElement="paragraph">
          { newDate }
        </ColumnItemWrapper>
        )
      }
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {  formatPipe((+record?.amount * +record?.rate) + "") }
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Referencia',
      dataIndex: 'reference',
      key: 'reference',
    },
  ]

  const makeRepeated = (arr, repeats) =>
    [].concat(...Array.from({ length: repeats }, () => arr))

  const onSave = async (): Promise<void> => {
    let date = new Date()

    let [year, month, day] = getYearMonthAndDay(
      transformDate(date.toISOString())
    )

    let body = {}

    // if (selectedOption?.value === 1) {
    if (isFromReturn) {
      console.log("items..", items)
      // let response = await axios.get(
      //   `${server}/finances/rate?date=${values.date}&currency=${values.account.currency}`
      // )
      if (returnedPayments.length === 0) {
        console.log("llega...")
        body = {
          id: purchase?.id,
        iva: purchase?.iva,
        igtf: purchase?.igtf,
        date: purchase?.date.replace(/T.+/, ''),
        // refunds: returnedPayments.map((v) => ({
        //   ...v,
        //   account: { id: v.account.id },
        // })),
        items: items?.map((v) => ({ id: v?.id, returned: v?.return })),
        // totalRefund: returnedPayments.reduce((a, b) => +a + +b?.amount, 0) + '',
        totalRefund: toFixed(items.reduce((a, b) => {
          console.log("b...", b)
          let result = +b.return * +onGetRate(b?.currency?.id) * (+b.price || b?.item?.cost || b?.cost)
          return a + result * getIvaNumber(b?.ivaType)
        }, 0), 2)
        }
      } else {
        body = {
          id: purchase?.id,
          iva: purchase?.iva,
          igtf: purchase?.igtf,
          date: purchase?.date.replace(/T.+/, ''),
          refunds: returnedPayments.map((v) => ({
            ...v,
            account: { id: v.account.id },
          })),
          items: items?.map((v) => ({ id: v?.id, returned: v?.return })),
          // totalRefund: returnedPayments.reduce((a, b) => +a + +b?.amount, 0) + '',
          totalRefund: toFixed(items.reduce((a, b) => {
            console.log("b2...", b)
            let result = +b.return * +onGetRate(b?.currency?.id) * (+b.price || +b?.item?.cost || +b?.cost)
            return a + result * getIvaNumber(b?.ivaType)
          }, 0), 2)
        }
      }
    } else {
      let refunds = returnedPayments.reduce((a, b) => {
        if (b?.state !== 'old') {
          return [
            ...a,
            {
              ...b,
              account: { id: b.account.id },
            },
          ]
          // return {
          //   ...b,
          // account: { id: b.account.id },
          // }
        }
        return a
      }, [])
      body = {
        id: purchase?.id,
        refunds,
      }
    }
    // } else {
    // let creditLocal : any = credit.current
    // creditLocal.startDate = dateToDB(creditLocal.startDate)
    // creditLocal.finalDate = creditLocal.finalDate.replace(/T.+/, "")
    // body = {
    //   id: purchase?.id,
    //   iva: purchase?.iva,
    //   igtf: purchase?.igtf,
    //   date: purchase?.date.replace(/T.+/, ''),
    //   items: items?.map((v) => ({ id: v?.id, returned: v?.return })),
    //   credit: creditLocal
    // }
    // }

    console.log('body...', body)
    try {
      addAlert({
        message: 'Creando devolución...',
        status: 'loading',
      })
      let response = await axios.post(
        `${server}/${url}/${isFromReturn ? 'return' : 'refund'}`,
        body
      )
      // onSaveProp(response.data.noteCode)
      onClose && onClose(true, response?.data?.noteCode, items)
      addAlert({
        message: 'Devolución creada con éxito',
        status: 'success',
      })
    } catch (err) {
      addAlert({
        message: 'Error al crear devolución',
        status: 'error',
      })
    }
  }

  return (
    <>
      <h2 className="ml-5 mb-5 text-primary dark:text-white font-bold text-3xl">
        Devoluciones
      </h2>

      <div
        className="grid grid-cols-12 auto-rows-fr gap-4"
        style={{ height: '100%' }}
      >
        <div
          className="col-span-6 flex flex-col justify-between"
          style={{ height: '100%', overflow: 'auto' }}
        >
          <div style={{ maxHeight: '80%', overflow: 'auto' }}>
            <Table columns={itemsColumns} data={items} showPagination={false} />
          </div>

          <div className="flex flex-row">
            <Button
              type="outline"
              classes="w-1/2 mr-4"
              onClick={() => onClose && onClose(false)}
              htmlType="button"
            >
              Cancelar
            </Button>
            <Button
              type="primary"
              classes="w-1/2 mr-4"
              onClick={() => onSave()}
            >
              Guardar cambios
            </Button>
          </div>
        </div>

        <div className="col-span-6">
          <div
            className="grid grid-cols-12 grid-rows-12 auto-rows-fr gap-4"
            style={{ height: '100%' }}
          >
            <div
              className="dark:bg-black bg-primaryGray-1300 col-span-6 row-span-2 p-3"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <h2
                className="text-xs font-medium mb-1"
                style={{ color: '#006AEA' }}
              >
                Monto total
              </h2>
              <h2 className="text-xs font-medium mb-1">
                Descuento: {purchase?.discount}
              </h2>
              <h2 className="text-xs font-medium mb-1">
                IVA (16%): {purchase?.iva}
              </h2>
              <h2 className="text-xs font-medium mb-1">
                IGFT: {purchase?.igtf}
              </h2>
              <h2 className="text-xs font-medium mb-1">
                Monto total: {purchase?.cost}
              </h2>
              <h2 className="text-xs font-medium mb-1">
                Monto total en usd: {purchase?.usdCost}
              </h2>
            </div>
            <div
              className="dark:bg-black bg-primaryGray-1300 col-span-6 row-span-2 p-3"
              style={{
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              <div className="flex flex-row mb-1">
                <IoDocumentAttachSharp className="text-primary mb-2 mr-3" />
                <h2
                  className="text-xs font-medium"
                  style={{ color: '#006AEA' }}
                >
                  {purchase?.provider ? 'Datos del proveedor' : 'Datos del ciente'}
                </h2>
              </div>

              <h2 className="text-xs font-medium mb-1">
                Razón social: {purchase?.provider?.businessName || purchase?.client?.businessName || purchase?.client?.name}
              </h2>
              {/* <h2 className="text-xs font-medium mb-1">
                Nombre comercial: Las 3 Marias
              </h2> */}
              <h2 className="text-xs font-medium mb-1">
                Documento: {purchase?.provider?.documentType || purchase?.client?.documentType}-
                {purchase?.provider?.document || purchase?.client?.document}
              </h2>
              {/* <h2 className="text-xs font-medium mb-1">
                Dirección Fiscal: Av Bella vista calle 80{' '}
              </h2> */}
            </div>

            <div
              className="dark:bg-black bg-white col-span-12 row-span-5 p-3"
              style={{
                height: '100%',
                overflow: 'auto',
                borderRadius: 6,
                boxShadow: theme === 'light' ? '0px 3px 4px 3px #cccccc40' : '',
              }}
            >
              {/* <div className="flex flex-row justify-between">
                <h2
                  className="text-xs font-medium mb-3"
                  style={{ color: '#006AEA' }}
                >
                  Reembolso
                </h2>
                <Select options={options} defaultValue={options[0]} onChange={(value) => {
                  setSelectedOption(value)
                }} />
              </div> */}
              <ReturnForm
                onAddReturn={async (values) => {
                  let date1Format = purchase?.date?.replace(/T.+/, '')
                  const [year, month, day] = values.date.split("-")
                  let date2Format = new Date(year, month - 1, day).toISOString()
                  let d2Format = date2Format?.replace(/T.+/, '')
                  let d1 = DateTime.fromISO(date1Format)
                  let d2 = DateTime.fromISO(d2Format)
                    // console.log('values...', values)
                    values.amount = +formatPipe(values.amount, true)
                    if (values.account.currency !== '2') {
                      let response = await axios.get(
                        `${server}/finances/rate?date=${values.date}&currency=${values.account.currency}`
                      )
                      values.rate = response.data.rate.rate
                    } else {
                      // console.log("values amount", +formatPipe(values.amount, true))
                      values.rate = '1'
                    }
                    setReturnedPayments((prevState) => [...prevState, values])
                  
                }}
              />

              {/* {selectedOption?.value === 2 && (
                <ReturnFormCredit onAddReturn={(values) => {
                  console.log("values...", values)
                  // setCredit(values)
                  credit.current = values
                }} />
              )} */}
              <Table
                columns={returnColum}
                data={returnedPayments}
                showPagination={false}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

interface IPurchase {
  purchase: any
  onClose?: Function
  isFromReturn: boolean
  url?: string
}

export default Return
